export enum ProfileTabs {
	collections = 'collections',
	animus = 'animus',
	purchases = 'purchases',
}
